import {useState} from "react";

export type ForceUpdateFunction = () => void;

export function useForceUpdate(): ForceUpdateFunction {
    const [value, setValue] = useState(0);
    return () => setValue(() => value + 1);
}